import { PplUiIntl } from '../ppl-ui-intl';
import { NG_UI_THEMES, PIPELINER_NG_UI_THEME } from '../tokens';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormValueControl } from '@ppl/utils/form.utils';
import type {
  OnInit
} from '@angular/core';

@Component({
  selector: 'ppl-search',
  templateUrl: 'search.component.html',
  styleUrls: ['search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PplSearchComponent),
      multi: true
    }
  ],
  standalone: false
})
@FormValueControl()
export class PplSearchComponent implements OnInit {

  @Input() value = '';
  @Input() alwaysDisplayRemoveButton = false;
  @Input() placeholder: string | null = null; // null is default Search placeholder (translated)
  @Input() focusOnMount = false;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<string>();
  @Output() valueRemove = new EventEmitter<null>();
  @Output() valueFocus = new EventEmitter();
  @Output() valueBlur = new EventEmitter();
  @Output() keyEscapePressed = new EventEmitter<null>();

  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;

  get inputValue() {
    return this.value === null ? '' : this.value;
  }

  get isFocused() {
    return this.searchInput?.nativeElement === document.activeElement;
  }

  constructor(
    @Inject(PIPELINER_NG_UI_THEME) public ngUiTheme: NG_UI_THEMES,
    private intl: PplUiIntl,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.focusOnMount) {
      this.focusInput();
    }

    if (this.placeholder === null) {
      this.placeholder = this.intl.search;
    }
  }

  onChange(event: KeyboardEvent) {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }

  clearValue() {
    this.valueChange.emit('');

    if (this.alwaysDisplayRemoveButton) {
      this.valueRemove.emit();
    }
  }

  onKeyEscapePressed() {
    this.keyEscapePressed.emit(null);
  }

  focusInput() {
    this.searchInput?.nativeElement?.focus();
  }
}
